import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import EmployeeProfileContainer from '../../containers/employees/EmployeeProfileContainer.jsx';

const EmployeeProfile = ({ slug, employeeId, search }) => (
  <>
    <Helmet>
      <title>Employee Profile | ChangeSync</title>
    </Helmet>
    <EmployeeProfileContainer
      slug={slug}
      employeeId={employeeId}
      search={search}
    />
  </>
);

EmployeeProfile.getInitialProps = ({ query }) => ({
  slug: query.slug,
  employeeId: Number(query.employeeId),
  search: query.search || '',
});

export default requireAuth(withRouterParams(EmployeeProfile));
